export const treatmentSeoData: Record<string, { title: string; description: string }> = {
  'grundlaeggende-principper': {
    title: 'Viden om akupunktur og grundlæggende principper',
    description: 'Bliv klogere på klassisk kinesisk medicins principper. Hos Lykke Terapien får du indsigt i, hvordan akupunktur skaber helhed og velvære.'
  },
  'psykiske-neurologiske-virkninger': {
    title: 'Akupunktur mod stress, angst & depression',
    description: 'Oplev hvordan akupunktur kan lindre stress, angst og depression. Lykke Terapien i Horsens tilbyder behandling i trygge rammer.'
  },
  'fysisk-helbred-smertelindring': {
    title: 'Smertelindring med akupunktur | Bestil tid',
    description: 'Få naturlig smertelindring gennem akupunktur i Horsens. Lykke Terapien hjælper mod både akutte og kroniske smerter. Book tid her.'
  },
  'indre-organer-systemer': {
    title: 'Akupunktur | Fordøjelse, Allergi & Astma | Book nu',
    description: 'Akupunktur kan afhjælpe problemer med fordøjelse, allergi og astma. Hos Lykke Terapien i Horsens skræddersyes behandlingen til dig.'
  },
  'stress': {
    title: 'Akupunktur mod stress | Book tid',
    description: 'Slip spændinger og find ro med akupunktur mod stress. Hos Lykke Terapien i Horsens får du behandling tilpasset din livssituation.'
  },
  'søvnløshed': {
    title: 'Akupunktur mod søvnløshed og søvnproblemer',
    description: 'Få bedre søvn med akupunktur i Horsens. Lykke Terapien hjælper ved søvnløshed og uro, så du kan vågne udhvilet og med mere energi.'
  },
  'fertilitet-kvindesundhed': {
    title: 'Akupunktur fertilitet, graviditet & fødsel',
    description: 'Akupunktur kan støtte fertilitet, graviditet og fødsel. Hos Lykke Terapien i Horsens hjælper vi dig trygt gennem livets faser.'
  },
  'helhedsorienteret-tilgang': {
    title: 'Vores helhedsorienteret tilgang | Lykke Terapien',
    description: 'Hos Lykke Terapien i Horsens ser vi kroppen som en helhed. Vores behandlinger fokuserer på årsager frem for kun symptomer.'
  },
  'moxa-terapi': {
    title: 'Moxa terapi behandling | Book tid',
    description: 'Moxa terapi styrker kroppens energi og skaber balance. Hos Lykke Terapien i Horsens tilbyder vi denne traditionelle behandlingsform.'
  },
  'nada-protokol': {
    title: 'NaDa akupunktur | Bestil tid',
    description: 'NaDa-akupunktur kan afhjælpe uro, afhængighed og stress. Hos Lykke Terapien i Horsens tilbydes skånsomme og effektive forløb.'
  },
  'oreakupunktur': {
    title: 'Øreakupunktur | Bestil tid',
    description: 'Øreakupunktur kan lindre både fysiske og psykiske ubalancer. Lykke Terapien i Horsens tilbyder behandling i rolige omgivelser.'
  },
  'cupping': {
    title: 'Cupping behandling Horsens | Bestil tid',
    description: 'Få løsnet spændinger og forbedret blodcirkulation med cupping. Hos Lykke Terapien i Horsens er behandlingen skånsom og effektiv.'
  },
  'gua-sha': {
    title: 'Gua Sha massage i Horsens | Bestil tid',
    description: 'Gua Sha massage øger blodgennemstrømning og frigør spændinger. Prøv en helende behandling hos Lykke Terapien i Horsens.'
  }
};